/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = None 1 = Block 2 = Allow
 */
export type BotCategorizationAction = 0 | 1 | 2;

export const BotCategorizationAction = {
  None: 0 as BotCategorizationAction,
  Block: 1 as BotCategorizationAction,
  Allow: 2 as BotCategorizationAction,
};
